import { useMemo } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { useMatchingRuns } from '../api/usePairMapper';

export const ALL_RUNS_SENTINEL = '__all_runs__';

interface Props {
  value: string | null;
  onChange: (runId: string | null) => void;
}

function formatRunLabel(startedAt: string, trigger: string): string {
  const d = new Date(startedAt);
  if (Number.isNaN(d.getTime())) return startedAt;
  const date = d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${date} ${time} · ${trigger}`;
}

export const RunSelector = ({ value, onChange }: Props) => {
  const { data } = useMatchingRuns({ limit: 50, offset: 0 });

  const options = useMemo(() => {
    return (
      data?.runs.map((r) => ({
        id: r._id,
        label: formatRunLabel(r.startedAt, r.trigger),
        matches: r.matchesCreated,
      })) ?? []
    );
  }, [data]);

  return (
    <TextField
      size="small"
      label="Run"
      select
      value={value ?? ALL_RUNS_SENTINEL}
      onChange={(e) =>
        onChange(
          e.target.value === ALL_RUNS_SENTINEL ? null : e.target.value,
        )
      }
      sx={{ width: 260 }}
    >
      <MenuItem value={ALL_RUNS_SENTINEL}>All runs</MenuItem>
      {options.map((o) => (
        <MenuItem key={o.id} value={o.id}>
          {o.label} ({o.matches})
        </MenuItem>
      ))}
    </TextField>
  );
};
